class global {
    fetchCurrentYear() {
        var date = new Date();
        return date.getFullYear();
    };

    orderBy(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a, b) {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
        }
    };

    onKeyPressDecimals = (e) => {
        const reg = /^-?[0-9]*(\.[0-9]*)?$/;
        const pressedKey = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (!reg.test(pressedKey)) {
            e.preventDefault();
            return false;
        }
    };

    onBlurDecimals = (e, decimals) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(decimals)))
            return parseFloat(0).toFixed(decimals);
        else
            return parseFloat(e.target.value).toFixed(decimals);
    };

    onBlurFilterDecimals = (e, decimals) => {
        if (e.target.value === '' || isNaN(parseFloat(e.target.value).toFixed(decimals)))
            return '';
        else
            return parseFloat(e.target.value).toFixed(decimals);
    };

    formatSearch(value) {
        if ([undefined, null].includes(value))
            value = '';

        value = value.toString().toLowerCase();
        value = value.replace(new RegExp('á', 'g'), 'a');
        value = value.replace(new RegExp('é', 'g'), 'e');
        value = value.replace(new RegExp('é', 'g'), 'i');
        value = value.replace(new RegExp('ó', 'g'), 'o');
        value = value.replace(new RegExp('ú', 'g'), 'u');
        value = value.trim();

        return value;
    };

    formatParameter(object) {
        var encodedString = '';
        for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
                if (encodedString.length > 0) {
                    encodedString += '&';
                }
                encodedString += encodeURI(prop + '=' + object[prop]);
            }
        }
        return encodedString;
    };

    formatDocuments = (querySnapshot) => {
        var items = [];
        querySnapshot.forEach((doc) => {
            var item = doc.data();
            item.id = doc.id;
            items.push(item);
        });
        return items;
    };
}
export default new global();